import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Login, Home, Registration } from "pages";
import UpdateProfile from "pages/updateProfile";
import BillingPlans from "pages/billings_plans";
import MembershipCard from "pages/viewMembershipCard";
import ViewProfile from "pages/home/components/viewProfile";
import KYCDocumantation from "pages/kyc";
import MembershipSelection from "pages/billings_plans/components/membershipSelection";
import ApplicationDetails from "pages/billings_plans/components/applicationDetails";
import PaymentResult from "pages/billings_plans/components/payment";
import CheckMembership from "pages/checkMembership/checkMembership";
import { ResetPassword } from "pages/login/resetPassword";
import { ConfirmPassword } from "pages/login/confirmPassword";
import MemebershipsList from "pages/memberships/membershipsList";
import MemebershipsDetails from "pages/memberships/membershipDetails";
import Desktop from "homepage/Desktop";
import { SetPassword } from "pages/reset_password";
import { TermsConditions } from "homepage/termsCondition";
import { PrivacyPolicy } from "homepage/privacyPolicy";
import { FAQanaAnswer } from "homepage/faqQuation";
import { AboutUs } from "homepage/aboutUs";
import { EnrolledPlans } from "pages/memberships/enrolledPlans";
import { ContactUs } from "homepage/contactUs";
import { EnrollApplicationDetails } from "pages/memberships/enrollApplicationDetails";
import { PartnerWithus } from "homepage/partnerWithUs";
import { SecurityTerms } from "pages/securityTerms";
import { Billing } from "pages/managepayments/billing";
import { InvoiceAndRecept } from "pages/managepayments/invoiceandrecept";
import { Contactus } from "pages/help/contactUs";
import { Faq } from "pages/help/faq";
import Test from "pages/home/test";
import { DashboardD } from "pages/dashboard";
import DashboardDemo from "pages/dashboard/DashboardDemo";
import DashBEnrollPI from "pages/dashboard/dashBEnrollPl/dashBEnrollPI";
import PricingPlans from "homepage/PricingPlans/PricingPlans";
import Partners from "pages/partners";
import AfterRegistration from "pages/registration/afterRegistration";
import ConfirmationPasswordMessage from "pages/login/confirmationPasswordMessage";
import ScrollToTop from "components/scrollToTop";
import EditMembership from "pages/memberships/editMembership";
import Plans from "pages/plans/plans";
//import Partners from "pages/partners";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Desktop />} path="*" />

        <Route element={<Desktop />} path="/" />
        <Route element={<DashboardD />} path="/dashboard" />
        <Route element={<DashboardDemo />} path="/dashboard-demo" />
        <Route element={<Login />} path="/login" />
        <Route element={<Registration />} path="/register" />
        <Route element={<DashBEnrollPI />} path="/dashBEnrollPI/:id" />
        {/* Home Page */}
        <Route element={<FAQanaAnswer />} path="/faq" />
        <Route element={<AboutUs />} path="/aboutus" />
        <Route element={<PricingPlans />} path="/pricingPlans" />
        <Route element={<AfterRegistration />} path="/afterRegistration" />
        {/*HOME  */}
        {/* <Route element={<Home />} path="/plans" /> */}
        <Route element={<MembershipSelection />} path="/selectedPlan/:id" />
        <Route element={<ApplicationDetails />} path="/membershipForm/:id" />
        {/* Membership */}
        <Route element={<EnrolledPlans />} path="/enrolledPlans" />
        {/* <Route element={<EnrollApplicationDetails />} path="/enrollApplicationDetailsForm/:id" /> */}
        <Route element={<MemebershipsList />} path="/memberships" />
        <Route
          element={<MemebershipsDetails />}
          path="/membershipDetails/:id"
        />
        <Route element={<EditMembership />} path="/editmembership/:id" />

        <Route
          element={<EnrollApplicationDetails />}
          path="/enrollApplicationDetailsForm/:id"
        />
        <Route element={<MemebershipsList />} path="/memberships" />
        <Route
          element={<MemebershipsDetails />}
          path="/membershipDetails/:id"
        />

        {/* KYc */}
        <Route element={<KYCDocumantation />} path="/kyc" />
        {/* <Route element={<KYCDocumantation />} path='/kyc/:id'/> */}
        {/* Profile  */}
        <Route element={<ViewProfile />} path="/profile" />
        <Route element={<UpdateProfile />} path="/updateProfile" />
        {/* Reset Password */}
        <Route element={<SetPassword />} path="/setPassword" />
        <Route element={<SecurityTerms />} path="/securityTerms" />
        {/* Manage payments */}
        <Route element={<Billing />} path="/billing" />
        <Route element={<InvoiceAndRecept />} path="/invoicerecept" />
        {/* Help */}
        <Route element={<Contactus />} path="/contactussid" />
        <Route element={<Faq />} path="/faqsid" />
        {/* CheckMembership */}
        <Route element={<CheckMembership />} path="/checkMembership" />
        {/* Forgot Password */}
        <Route element={<ResetPassword />} path="/resetPassword" />
        <Route
          element={<ConfirmationPasswordMessage />}
          path="/resetConfirmation"
        />
        <Route element={<ConfirmPassword />} path="/setPassword/:id" />
        {/* terms & privacyPolicy */}
        <Route element={<TermsConditions />} path="/termsConditions" />
        <Route element={<PrivacyPolicy />} path="/privacyPolicy" />
        <Route element={<ContactUs />} path="/contactUs" />
        <Route element={<PartnerWithus />} path="/partnerwithus" />
        <Route element={<BillingPlans />} path="/billingplans/:id" />
        <Route element={<PaymentResult />} path="/payment/:id" />
        <Route element={<Partners />} path="/partners" />
        <Route element={<MembershipCard />} path="/membershipcard" />
        {/* test */}
        <Route element={<Test />} path="/test" />
        <Route element={<Plans />} path="/plans" />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
